import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchProducts } from "./products.service";
import { ProductsRequest, ProductsResponse } from "./products.types";
import { handleApiError } from "@/app/utils/handleApiError";

/**
 * Get products with filters
 */
export const getProducts = createAsyncThunk<
  ProductsResponse,
  ProductsRequest,
  { rejectValue: string }
>("products/getProducts", async (params, { rejectWithValue }) => {
  try {
    const response = await fetchProducts(params);
    return response;
  } catch (error) {
    return rejectWithValue(handleApiError(error));
  }
});